import { useUserStore } from "@/modules/auth/store/user";
import { Button } from "@/components/common/Button";
import { Icon } from "@/components/common/icon/Icon";
import { handleCopyShareBotLink } from "@/modules/auth/utils/share";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { AnalyticsEvents } from "@/shared/utils/analytics/events";
import WebApp from "@twa-dev/sdk";
import Skeleton from "@/components/common/Skeleton";

const ReferralLink = () => {
  const { t } = useTranslation();
  const { refcode, isReferralLoading } = useUserStore();
  const isMiniApp = !!WebApp.initData;

  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    const success = await handleCopyShareBotLink(refcode, isMiniApp);

    if (success) {
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 3000);
    }
  };

  return (
    <div className="w-full flex flex-col">
      <p className="p-4 pb-2 text-[0.8125rem] leading-[1rem] text-section-header-text tracking-tighter uppercase">
        {t("network-page.your_referral_id")}
      </p>
      <div className="flex items-center justify-between gap-4 px-4 bg-bg rounded-[0.75rem]">
        <div className="flex items-center gap-4">
          <Icon type="person-add" className="shrink-0 w-10 h-10 fill-link" />

          <div className="flex flex-col py-3 gap-0.5">
            {isReferralLoading ? (
              <Skeleton className="w-20 h-5.5" />
            ) : (
              <p className="text-[1.0625rem] leading-[1.375rem] text-text">
                {refcode || "\u00A0"}
              </p>
            )}
            <p className="text-[0.9375rem] leading-[1.25rem] text-subtitle-text">
              {t("network-page.share")}
            </p>
          </div>
        </div>

        <Button
          onClick={handleCopy}
          text={t(copied ? "main-page.copied" : "main-page.copy")}
          size="small"
          mode={copied ? "gray" : "filled"}
          disabled={isReferralLoading}
          pilled
          analyticsEvent={AnalyticsEvents.Network.CopyInviteId}
        />
      </div>
    </div>
  );
};

export default ReferralLink;
